import { get_addon_byId } from 'pages/details/addon-detail.service'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

export function useAddonDetails(id:any) {
    const {t} = useTranslation()

    const { isLoading,...result} = useQuery(['addons-details',t,id], async () => {
        const { response } = await get_addon_byId(id)
        if (response) return response
    })

    return { ...result, addon: result.data?? {} , isLoading}
}